export const pexels = () => (
  <path
    fill="#000"
    d="M5.82 15.952h4.598v-4.466h1.39a3.719 3.719 0 1 0 0-7.438H5.818zm6.979 2.381h-9.36V1.667h8.368a6.1 6.1 0 0 1 .992 12.119z"
  />
);
